export default {

	init() {
		console.log('init header...');
		document.addEventListener("DOMContentLoaded", this.bindEvents);
	},

	bindEvents() {
		// $('#cycle').on('click', function(){
		// 	console.log('made it');
		// 	Header.cycleAnnouncementAnimation();
		// });

		$('.home-hero-disclosures .expand-disclosure .expand-text').on('click', function(){
			const parentDiv = $(this).closest('.home-hero-disclosures');
			parentDiv.toggleClass('expanded');
		});

		setTimeout(function(){
			Header.cycleAnnouncementAnimation();
			setInterval(Header.cycleAnnouncementAnimation, 9000);	
		}, 3000);
	},

	cycleAnnouncementAnimation() {
		const announcement = $('#header-announcement');
		if(announcement.hasClass('showing')) {
			announcement.removeClass('showing');
			setTimeout(function(){
				announcement.addClass('showing');
			}, 1200);
		} else {
			setTimeout(function(){
				announcement.addClass('showing');
			}, 700);
		}
	}

};
